<section>
  <div class="tw-flex tw-justify-end">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <app-sms-smart [borrower]="data.borrower"></app-sms-smart>
</section>
